<script>
    export let value = 0;
</script>

<style>
    .progress {
        height: 6px;
    }
</style>

<div class="progress">
  <div 
    class="progress-bar progress-bar-striped progress-bar-animated" 
    role="progressbar" 
    aria-valuenow={value} 
    aria-valuemin="0" 
    aria-valuemax="100" 
    style={`width: ${value}%`}></div>
</div>